import { time, Entity, coreEngine } from "@dinahmoe/dmafjs-core";

class Smoother extends Entity {
  namespace = "control:smoother";
  handlers = {
    "value.in": this.setSmoothedValue,
    "value.target": this.setValueTarget,
  };

  init(node) {
    node.isRunning = false;
    node.isDestroyed = false;
    node["value.out"] = 0;
    node._valueSmoothed = 0;
  }

  setSmoothedValue(node) {
    if (!node.props["smoothing.active"]) {
      return;
    }

    let valueNext;
    if (node["smoothing.mode"] === "delta") {
      valueNext =
        node.props["value.target"] + node.props["value.in"] * node.props["smoothing.speed"];
    } else {
      valueNext = node.props["value.in"] * node.props["smoothing.speed"];
    }

    node["value.target"] = this._validate(valueNext, node);
  }

  setValueTarget(node) {
    if (!node.isRunning) {
      node.isRunning = true;
      time.preUpdate(this.run.bind(this, node));
    }
  }

  reset(node, config) {
    node.isRunning = false;

    let valueTarget = this._validate(config.valueOut, node);

    node["value.out"] = node._valueSmoothed = node["value.target"] = valueTarget;

    if (node._targetNode) {
      node._targetNode[node["target.property"]] = node["value.out"];
    }
  }

  run(node) {
    if (node.isDestroyed) {
      return;
    }

    node._valueSmoothed = this.lerp(
      node._valueSmoothed,
      node["value.target"],
      node["smoothing.factor"]
    );

    const diff = Math.abs(node._valueSmoothed - node["value.target"]);
    const diffResolution = diff * Math.pow(10, node["smoothing.resolution"]);

    if (diffResolution < 1) {
      node["value.out"] = node["value.target"] = node._valueSmoothed;
      node.isRunning = false;
      return;
    }

    node["value.out"] = node._valueSmoothed;

    if (node["target.uid"]) {
      coreEngine.update({
        uid: node["target.uid"],
        key: node["target.property"],
        value: node["value.out"],
      });
    }

    time.nextFrame(this.run.bind(this, node));
  }

  lerp(a, b, n) {
    return (1 - n) * a + n * b;
  }

  _validate(value, node) {
    let validatedValue = value;
    
    if (node["value.min"] !== undefined) {
      validatedValue = Math.max(validatedValue, node["value.min"]);
    }
    if (node["value.max"] !== undefined) {
      validatedValue = Math.min(validatedValue, node["value.max"]);
    }

    if (node["value.min"] !== undefined && node["value.max"] !== undefined && node["value.max"] < node["value.min"]) {
      this.warn(node, 'value.max is below value.min, setting value to value.min');
      validatedValue = node["value.min"];
    }

    return validatedValue;
  }

  destroy(coreNode) {
    coreNode.isDestroyed = true;
    super.destroy(coreNode);
  }
}

const smoother = new Smoother();
export { smoother, Smoother };
